const { REACT_APP_THINKIFIC_ENDPOINT } = process.env;

// eslint-disable-next-line import/prefer-default-export
export const RECOVERY_PASSWORD_URL = `https://courses.${REACT_APP_THINKIFIC_ENDPOINT}/forgot_password`;
export const PASSWORD_REQUIRED = 'Password is required';
